// Data sevice
import axios from 'axios'
import authHeader from './auth-header'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const API_URL = process.env.VUE_APP_API_URL;

class SubategoriesService {

    index() {
        return axios.get(API_URL + 'sub-categories', { headers: authHeader() })
    }
    show(id) {
        return axios.get(API_URL + 'sub-categories/' + id, { headers: authHeader() })
    }
    store(resource) {
        return axios.post(API_URL + 'sub-categories', resource, { headers: authHeader() })
    }
    update(resource) {
        return axios.put(API_URL + 'sub-categories/' + resource.id, resource, { headers: authHeader() })
    }
    delete(resource) {
        return axios.delete(API_URL + 'sub-categories/' + resource.id, { headers: authHeader() })
    }

    getBycategory(id) {
        console.log("Fetching subcategories for category ID:", id);
        return axios.get(API_URL + 'sub-categories-for/' + id, { headers: authHeader() })
    }

    getGroups(id) {
        return axios.get(API_URL + 'get-groups/' + id, { headers: authHeader() })
    }
}

export default new SubategoriesService()